const themeConfig = {
  defaultLogo: "/images/tapp.png",
  themes: [
    {
      name: "christmas",
      logo: "/images/tapp_logo_christmas_edition.png",
      start: "12-13",
      end: "01-13",
    },
    {
      name: "easter",
      logo: "/images/tapp_logo_easter.png",
      start: "03-30",
      end: "04-06",
    },
    // {
    //   name: "summer",
    //   logo: "/images/tapp_logo_summer.png",
    //   start: "06-01",
    //   end: "08-31",
    // },
  ],
};

export default themeConfig;
